import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { TestVisibilities } from '@models/test-visibilities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SitesService {
  private http = inject(HttpClient);

  /**
   * Retrieves test visibilities for a given site ID.
   *
   * @param {string} siteId the ID of the site for which test visibilities are requested
   *
   * @returns {Observable<TestVisibilities>} an observable that emits test visibilities
   */
  public getTestVisibilities(siteId: string): Observable<TestVisibilities> {
    return this.http.get<TestVisibilities>(`${environment.analyteCareApi}/api/v2/sites/${siteId}/test-visibilities`);
  }
}
